import React, {useState, useCallback, useRef} from 'react';
import s from '../CreateInvoice.module.css';
import CategorySelector from '../../../Components/CategorySelector/CategorySelector';

import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {CategoryInListType} from '../../../types/ProductSliceTypes';
import {useGetCategoriesListQuery} from '../../../redux/DepotSlice/depotOrdersApi';
import {useFormikContext} from 'formik';
import {useClickOutside} from '../../../hooks/useClickOutside';
type Props = {
	setCategoryId: (categoryId: number) => void;
	fieldName?: string;
	scrollToList?: () => void;
};
const CategorySelectorsList: React.FC<Props> = ({
	fieldName,
	setCategoryId,
	scrollToList,
}) => {
	const {data, isLoading} = useGetCategoriesListQuery('store_order');
	const [openCategoryId, setOpenCategoryId] = useState<string | null>(null);
	const {setFieldValue} = useFormikContext();

	const handleChangeCategory = (id: number) => {
		setCategoryId(id);
		/*setOpenCategoryId(null);*/
	};
	const handleToggleCategory = useCallback((categoryId: string) => {
		setFieldValue(fieldName ?? '', categoryId);
		setCategoryId(+categoryId);
		setOpenCategoryId((prev) => (prev === categoryId ? null : categoryId));
	}, []);
	return (
		<div className={s.categorySelectorContainer}>
			{!isLoading && data?.categories ? (
				data.categories?.map((item: CategoryInListType) => (
					<div className={s.side} key={item.category_id}>
						<CategorySelector
							setOpenCategoryId={setOpenCategoryId}
							field={fieldName ?? ''}
							title={item.name}
							subcategories={item.subcategories}
							handleChange={handleChangeCategory}
							isOpen={openCategoryId === item.category_id}
							onToggle={() => handleToggleCategory(item.category_id)}
							scrollToList={scrollToList}
						/>
					</div>
				))
			) : (
				<PreLoaderComponent type={'category'} size={'big'} />
			)}
		</div>
	);
};

export default CategorySelectorsList;
